function getPageFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return parseInt(urlParams.get("page"));
}

$(document).ready(function () {
    let articlesPerPage = 9;
    let $articles = $(".blog-articles .article");
    let $filteredArticles = $articles; // Start with all articles
    let totalArticles = $filteredArticles.length;
    let totalPages = Math.ceil(totalArticles / articlesPerPage);
    let currentPage = getPageFromUrl() || 1;

    function showPage(page) {
        let start = (page - 1) * articlesPerPage;
        let end = start + articlesPerPage;

        $articles.hide(); // Hide all first
        $filteredArticles.hide().slice(start, end).fadeIn(); // Only show filtered articles
    }

    function createPagination() {
        let $pagination = $(".pagination__list");
        $pagination.empty();
        if (totalPages > 1) {
            $pagination.append('<li class="pagination__item link prev"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></li>');

            for (let i = 1; i <= totalPages; i++) {
                $pagination.append(`<li class="pagination__item link ${i === currentPage ? 'active' : ''}" data-page="${i}">${i}</li>`);
            }

            $pagination.append('<li class="pagination__item link next"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></li>');
        }
    }

    function updatePagination() {
        $(".pagination__item").removeClass("active");
        $(`.pagination__item[data-page="${currentPage}"]`).addClass("active");
    }

    function updateUrl(page) {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);
        window.history.replaceState({}, '', url);
    }

    // Pagination Dot
    $(document).on("click", ".pagination__item[data-page]", function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        currentPage = parseInt($(this).attr("data-page"));
        updateUrl(currentPage);
        showPage(currentPage);
        updatePagination();
    });

    // Pagination Previous Button
    $(document).on("click", ".pagination__item.prev", function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (currentPage > 1) {
            currentPage--;
            updateUrl(currentPage);
            showPage(currentPage);
            updatePagination();
        }
    });

    // Pagination Next Button
    $(document).on("click", ".pagination__item.next", function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (currentPage < totalPages) {
            currentPage++;
            updateUrl(currentPage);
            showPage(currentPage);
            updatePagination();
        }
    });

    // Search Functionality
    $(".searchbar-input").on("input", function () {
        const keyword = $(this).val().toLowerCase();

        // Filter articles based on title or excerpt content
        $filteredArticles = $articles.filter(function () {
            const title = $(this).find(".card__heading").text().toLowerCase();
            return title.includes(keyword);
        });

        totalArticles = $filteredArticles.length;
        totalPages = Math.ceil(totalArticles / articlesPerPage);
        currentPage = 1; // Reset to first page when searching
        updateUrl(currentPage);

        showPage(currentPage);
        createPagination();
        updatePagination();
    });

    // Sort Functionality
    $("select.all-blog-select").on("change", function () {
        const sortValue = $(this).val();
        const $container = $(".blog-articles");
        // Convert NodeList to array
        const articlesArray = $articles.toArray();
    
        const clean = str =>
            str.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^\w\s]/gi, "");
    
        const getTitleText = el =>
            clean($(el).find(".card__heading").text().trim().toLowerCase());
    
        // Sort based on selected value
        if (sortValue === "A to Z" || sortValue === "Z to A") {
            articlesArray.sort((a, b) => {
                const titleA = getTitleText(a);
                const titleB = getTitleText(b);
                return sortValue === "A to Z"
                    ? titleA.localeCompare(titleB)
                    : titleB.localeCompare(titleA);
            });
        } else if (sortValue === "Oldest") {
            articlesArray.sort((a, b) => {
                const dateA = new Date($(a).find(".date-or-category").text().trim());
                const dateB = new Date($(b).find(".date-or-category").text().trim());
                return dateA - dateB;
            });
        } else if (sortValue === "Newest") {
            articlesArray.sort((a, b) => {
                const dateA = new Date($(a).find(".date-or-category").text().trim());
                const dateB = new Date($(b).find(".date-or-category").text().trim());
                return dateB - dateA;
            });
        }
    
        // Replace container with sorted articles
        $container.empty().append(articlesArray);
        $filteredArticles = $container.children(); // Reset for pagination
    
        totalArticles = $filteredArticles.length;
        totalPages = Math.ceil(totalArticles / articlesPerPage);
        currentPage = 1;
        updateUrl(currentPage);
        showPage(currentPage);
        createPagination();
        updatePagination();
    });    

    // Initialize
    showPage(currentPage);
    createPagination();
    updatePagination();
});
